import { createApp } from 'vue'
import StartPage from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from '@/store/index'
import ElementPlus from 'element-plus'


import { refreshPublicKey, showLoading, closeLoading, showMessage } from '@/tools'
import { i18n, tc } from '@/languages'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/themes/index.css'

axios.queue = 0;

axios.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + localStorage.getItem('JWT');
    if (axios.queue == 0) showLoading();
    axios.queue++;
    return config;
}, function (error) {
    if (error) {
        showMessage('error', tc('global.RequestFailed'))
    }
    return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
    axios.queue--;
    if (axios.queue == 0) closeLoading();
    // if (!res.data.success) {
    //     console.error(res.data.message);
    //     //showMessage('error', tc('global.ResponseFailed'));
    // }
    return res.data;
}, function (error) {
    axios.queue--;
    if (axios.queue == 0) closeLoading();
    if (error) {
        if (error.response.status === 401) {
            router.push({ name: "Login" });
        }
        showMessage('error', tc('global.ResponseFailed'))
    }
    return Promise.reject(error);
});

const $ = require("jquery");
window.$ = $;

refreshPublicKey();

createApp(StartPage)
    .use(ElementPlus)
    .use(VueAxios, axios)
    .use(router)

    .use(store)
    .use(i18n)
    .mount('#app');



   